module.exports = __webpack_public_path__ + "static/intro-a6b7309ca079d2df7d6a502ff4a3e777.mp4";